    <div fxLayout="column" fxFlex="100" fxLayoutGap="10">
        <h2>{{'admin-center.user.linkedUsers' | translate}}</h2>
        
        <button type="button" kendoButton (click)="addUserLink()" icon="plus" type="submit"> 
            {{'global.add' | translate}}
        </button>
        
        <div *ngFor="let linkedUser of linkedUsers$ |async" class="form-block">
            <div fxLayout="row" fxFlex="100">

                <button kendoButton look="flat" icon="delete" (click)="removeUserLink(linkedUser.id)"> </button>
                <div fxLayout="column">
                    <span> {{linkedUser.name}} {{linkedUser.surname}}</span>
                    <strong>{{linkedUser.normalizedUserName}}</strong>

                </div>
            </div>
        </div>
    </div>

<div kendoDialogContainer #technicianCenterCostEstimationDialog></div>